export default __webpack_public_path__ + "static/media/newSignatureWhite.d6670723.png";